import { _breakP } from './utils.js';
export default class panorama {
  constructor() {
    this.panoramaFunc();
  }

  panoramaFunc() {
    const $panoramaItem = document.querySelectorAll('.js-swipeFigure');
    if (!$panoramaItem.length) return;

    // ボタン処理はスクロールに依存しないため即座にセットアップ
    $panoramaItem.forEach(elm => {
      const icons = elm.querySelectorAll('.js-swipeFigureMove');
      if (!icons.length) return;

      icons.forEach($icon => {
        const isPrev = $icon.classList.contains('is-prev');
        const reg = _breakP.SP ? 2 : 0.75;
        let rafId = null;
        let isHovered = true;

        const step = () => {
          const container = elm.closest('.js-swipeFigure');
          container.scrollLeft = isPrev
            ? container.scrollLeft + reg * -1
            : container.scrollLeft + reg * 2;
          rafId = requestAnimationFrame(step);
        };

        $icon.addEventListener(_breakP.SP ? 'touchstart' : 'mouseover', e => {
          if (!isHovered) return;
          isHovered = false;
          rafId = requestAnimationFrame(step);
          e.preventDefault();
        });

        $icon.addEventListener(_breakP.SP ? 'touchend' : 'mouseleave', e => {
          isHovered = true;
          if (rafId !== null) {
            cancelAnimationFrame(rafId);
            rafId = null;
          }
          e.preventDefault();
        });
      });
    });

    // IntersectionObserverで各アイテムが個別にビューポートに入った時にscrollLeftを設定
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;

        const elm = entry.target;

        function setScrollPosition() {
          const halfValue = _breakP.SP ? 5 : 3;
          const elmImage = elm.querySelector('.photo__image');
          const elmW = elmImage.clientWidth;
          const elmHW = elmW / halfValue;
          let initPos = 0;

          if (elm.classList.contains('js-figPosition-center')) {
            initPos = elmHW;
          }
          if (elm.classList.contains('js-figPosition-right')) {
            initPos = elmW;
          }

          elm.scrollLeft = initPos;
        }

        if (elm.dataset.mode === 'sp') {
          if (_breakP.SP) setScrollPosition();
        } else if (elm.dataset.mode === 'pc') {
          if (!_breakP.SP) setScrollPosition();
        } else {
          setScrollPosition();
        }

        observer.unobserve(elm);
      });
    });

    $panoramaItem.forEach(elm => {
      observer.observe(elm);
    });
  }
}
